module.exports = __webpack_public_path__ + "img/img50.4cbbace0.svg";